jQuery(document).ready(function($) {
  $( "#vr_collection_sidebar_accordian" ).accordion({
    heightStyle: "content",
    collapsible: true, 
    active: false
  });  
  
  $( "#collection_sidebar_accordian" ).accordion({
    heightStyle: "content",
    collapsible: true, 
    active: false
  });
  
  if($('.current_sidebar_custom_collection_heading').length > 0) {
    $('.current_sidebar_custom_collection_heading')[0].click();
  }
});